import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// Fade out the instant HTML splash (public/index.html) once React has painted; it enforces a 1.5s minimum.
requestAnimationFrame(() => window.__ssHideSplash && window.__ssHideSplash());

// No saving media: block the right click / long press menu ("Save image", "Save video as") and dragging media out.
const isMedia = (t) => t instanceof Element && t.closest("img, video, audio");
document.addEventListener("contextmenu", (e) => { if (isMedia(e.target)) e.preventDefault(); });
document.addEventListener("dragstart", (e) => { if (isMedia(e.target)) e.preventDefault(); });

// Register the service worker used for Web Push notifications.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
